import axios from 'axios';

const API_URL =
    process.env.VUE_APP_API_URL ||
    'https://metersuite.wtmeters.it/api';

const axiosInstance = axios.create({
    baseURL: API_URL,
    // Wait beyond the 165s proxy and 150s backend transport budgets.
    timeout: 180000
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        if (config.data !== undefined) {
            config.headers['Content-Type'] = 'application/json';
        }
        return config;
    },
    (error) => Promise.reject(error)
);

class LlmChatApiService {
    async createChat({ title = 'Dashboard assistant', ttlMinutes = 120, firstUserMessage = '' } = {}) {
        const response = await axiosInstance.post('/llm/chats', {
            title,
            ttl_minutes: ttlMinutes,
            first_user_message: firstUserMessage
        });
        return response.data;
    }

    async sendMessage(chatId, { message, history = [], maxToolCalls = 4, progressId = '' } = {}) {
        const response = await axiosInstance.post(`/llm/chats/${encodeURIComponent(chatId)}/messages`, {
            message,
            history,
            max_tool_calls: maxToolCalls,
            progress_id: progressId
        });
        return response.data;
    }

    async getProgress(chatId) {
        const response = await axiosInstance.get(`/llm/chats/${encodeURIComponent(chatId)}/progress`, { timeout: 4000 });
        return response.data;
    }

    async closeChat(chatId) {
        if (!chatId) return null;
        const response = await axiosInstance.post(`/llm/chats/${encodeURIComponent(chatId)}/close`);
        return response.data;
    }

    async downloadArtifact(downloadUrl, fallbackName = 'llm-artifact.csv') {
        const response = await axiosInstance.get(downloadUrl.replace(/^\/api/, ''), {
            responseType: 'blob',
            headers: {
                Accept: 'text/csv, application/octet-stream'
            }
        });

        const disposition = response.headers?.['content-disposition'] || '';
        const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
        const filename = filenameMatch?.[1] || fallbackName;
        const blobUrl = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.className = 'llm-artifact-download-link';
        link.download = filename;
        link.addEventListener('click', event => event.stopPropagation());
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
    }
}

export default new LlmChatApiService();
